import React from 'react';
import { connect } from 'react-redux';

import { HAS_INSTANT_DISCOUNT, USE_PARITY, APPLICATION_ID, NO_DISCOUNT } from '../../../constants';

import { getRefundWording } from '../../../services/i18n/selector';

import {
    displayableCashback,
    getMerchantCardUrl,
    renderPluralConditional,
    hasOnAndOffCashback,
    hasEbonCashback
} from '../../../services/partner/utils';

import LocalizedNavLink from '../../router/LocalizedNavLink';

const mapStateToPropsResultCashback = state => {
    return {
        refundWording: getRefundWording(state, APPLICATION_ID),
        UPTO: state.i18n.feature.partenaire.jusqua
    };
};

const ResultCashbackEbon = connect(mapStateToPropsResultCashback)(
    ({ partner, REFUND, OFFERED, UPTO }) => {
        const ebonDiscount = USE_PARITY
            ? partner.ebonDiscount.parity
            : partner.ebonDiscount.cashback;
        return !NO_DISCOUNT && hasEbonCashback(partner) ? (
            <div className="value">
                <span>
                    {displayableCashback(ebonDiscount.percent.value, ebonDiscount.fixed.value)}
                </span>
                &nbsp;
                {renderPluralConditional(
                    HAS_INSTANT_DISCOUNT || USE_PARITY ? OFFERED : REFUND,
                    () =>
                        partner && (ebonDiscount.percent.value > 1 || ebonDiscount.fixed.value > 1)
                )}
            </div>
        ) : null;
    }
);

export const ResultComponent = ({ partner }) => (
    <li className={`resultat ${hasOnAndOffCashback(partner) ? 'large' : ''}`}>
        <LocalizedNavLink to={getMerchantCardUrl(partner, false, true)}>
            <div className="resultat-conteneur flex-container-h flex-center-alt">
                <div className="partnerName">{partner.name}</div>
                <div className="resultat-valeur">
                    <ResultCashbackEbon partner={partner} />
                </div>
            </div>
        </LocalizedNavLink>
    </li>
);



// WEBPACK FOOTER //
// ./src/components/header/search/ResultComponent.js